/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menupagedescription2Inputs */

const en_menupagedescription2 = /** @type {(inputs: Menupagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photograph today's specials, the weekly board or the menu: Pulsify reads it, you check it, and your guests see it in the app and on the web.`)
};

const de_menupagedescription2 = /** @type {(inputs: Menupagedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografier das Tagesangebot, die Wochentafel oder die Karte: Pulsify liest sie, du prüfst sie und deine Gäste sehen sie in der App und im Web.`)
};

/**
* | output |
* | --- |
* | "Photograph today's specials, the weekly board or the menu: Pulsify reads it, you check it, and your guests see it in the app and on the web." |
*
* @param {Menupagedescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menupagedescription2 = /** @type {((inputs?: Menupagedescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menupagedescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menupagedescription2(inputs)
	return de_menupagedescription2(inputs)
});
export { menupagedescription2 as "menuPageDescription" }